import { RootState } from 'types'

export default function reduce(
  state: RootState['breadcrumbsContext'] = null,
  { type, payload }: any,
): RootState['breadcrumbsContext'] {
  switch (type) {
    case 'BREADCRUMBS_CONTEXT_SET': {
      return payload
    }
    default:
      return state
  }
}
